export const STANDARD_HEADER_TOP_MARGIN = '48px';